<template>
  <avue-crud ref="" :option="option" :data="data">
    <template slot="projectName" slot-scope="scope">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.projectName"
          placement="top-start"
        >
          <el-button
            @click="
              toDetail('/fund/fundProjectManage/detail/?id=' + scope.row.id)
            "
            type="text"
            size="small"
          >
            {{ scope.row.projectName }}
          </el-button>
        </el-tooltip>
      </div>
    </template>

    <template slot="custName" slot-scope="scope">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          :content="scope.row.custName"
          placement="top-start"
        >
          <el-button
            @click="toDetail('/zd/customer/detail/' + scope.row.custId)"
            type="text"
            size="small"
          >
            {{ scope.row.custName }}
          </el-button>
        </el-tooltip>
      </div>
    </template>
  </avue-crud>
</template>

<script>
import * as api from "@/api/fund/subfunds";

export default {
  name: "accessory",
  data() {
    return {
      data: [],
      option: {
        menuType: "button",
        menuWidth: 380,
        menuAlign: "center",
        align: "center",
        card: false,
        tip: false,
        lazy: false,
        tree: false,
        addBtn: false,
        editBtn: false,
        cellBtn: false,
        delBtn: false,
        selection: false,
        searchBtn: false,
        columnBtn: false,
        filterable: false,
        refreshBtn: false,
        menu: false,
        column: [
          {
            label: "项目名称",
            prop: "projectName",
            slot: true,
          },
          // {
          //   label: "审核状态",
          //   prop: "auditState",
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          //   props: {
          //     label: "dictValue",
          //     value: "dictKey",
          //   },
          //   width: 100,
          // },
          {
            label: "基金投资金额",
            prop: "fundAmount",
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "带动社会投资额",
            prop: "societyAmount",
            formatter: (row, value, label, column) => {
              return value == -1 ? "-" : this.getMoney(value) + "元";
            },
          },
          {
            label: "客户名称",
            prop: "custName",
            slot: true,
          },
        ],
      },

      isOnly: false,
      checkUserList: [],
      peopleName: "",
      personStatus: "",
      topicId: -1, //议题id,
      loading: false,
    };
  },
  props: {
    id: {
      type: Number,
    },
  },

  components: {},
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.loading = true;
      api.getFundList({ id: this.id }).then((res) => {
        this.data = res.data.data;
      });
    },

    toDetail(url) {
      this.$router.push({ path: url });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  th {
    background: #f2f2f2;
    color: #333;
  }
}
.action_block {
  display: flex;
  flex-direction: row;
  a {
    cursor: pointer;
    margin: 0 8px;
  }
}
.del_color {
  color: #409eff;
}
.member_list_wrapper {
  display: flex;
  flex-wrap: wrap;
}
.flex_wrp {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
